import { Alert, Button, ConfigProvider, Layout } from "antd";
import React from "react";
import "../MainLayout.css";
import "./StatusPage.css";

const { Header, Content } = Layout;

const environment = process.env.REACT_APP_ENV;
const showEnvironmentBanner = environment && environment !== "production";

// Signed out / error page. Kept flat on purpose so that Bls.Identity remains the only page that looks like a login
export const StatusPage = ({
  icon,
  tone = "default",
  title,
  message,
  buttonLabel,
  onButtonClick,
  signInHint = false,
  notice = null,
  extra = null,
}) => {
  return (
    <Layout className="status-page">
      {showEnvironmentBanner && (
        <div className="env-banner">
          <svg
            className="env-banner-icon"
            viewBox="0 0 24 24"
            fill="currentColor"
            aria-hidden="true"
          >
            <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z" />
          </svg>
          <span>{environment.toUpperCase()} ENVIRONMENT</span>
        </div>
      )}
      <Header className="header-layout-parent">
        <div className="logoImage" />
      </Header>
      {notice && <Alert banner type="warning" message={notice} />}
      <Content className="status-page-content">
        <div className={`status-page-icon status-page-icon-${tone}`}>
          {icon}
        </div>
        <h1 className="status-page-title">{title}</h1>
        <p className="status-page-message">{message}</p>
        {extra && <div className="status-page-extra">{extra}</div>}
        <div className="status-page-actions">
          <ConfigProvider
            theme={{
              token: { colorPrimary: "#1c4658" },
              components: {
                Button: {
                  colorPrimaryHover: "#304f5c",
                  colorPrimaryActive: "#304f5c",
                },
              },
            }}
          >
            <Button type="primary" size="large" onClick={onButtonClick}>
              {buttonLabel}
            </Button>
          </ConfigProvider>
          {signInHint && (
            <span className="status-page-hint">
              You'll sign in on the Broker Link Software account page.
            </span>
          )}
        </div>
        <div className="status-page-footer">
          Need help? support@brokerlinksoftware.com
        </div>
      </Content>
    </Layout>
  );
};
